// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"1f0a9fc35d9728ef52ed","678":"8e2d5874a0a69309e320","883":"e946caaad80cf82d7598"}[chunkId] + ".js";
};